import { createSlice } from "@reduxjs/toolkit";

export const appInitialSlice = createSlice({
  name: "appInitial",
  initialState: {  
    appDefaultInformationSelect : false,
    initialUniqueParam : ""
  },
  reducers: { 
    onAppInitialValuesComplete: (state, action) => {
      state.initialUniqueParam = action.payload;
      return state;
    },
    
  },
});
export const { onAppInitialValuesComplete } = appInitialSlice.actions;

 

export const appInitialReducer = appInitialSlice.reducer;